<template>
  <div id="app" class="app.vue">
    <router-view :key="currentData"></router-view>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {};
  },
  name: "App",
  computed: {
    ...mapGetters(["currentData"])
  }
};
</script>

<style lang="scss" rel="stylesheet/scss">
@import "~@/styles/base.scss";
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue